import { getForm } from 'remote-com-shared/domains/hubspot/services';
import { getDocumentMeta } from 'remote-com-shared/domains/navigation/hrefResolver';

import { getSlicesContext, transformProperties } from '@/src/domains/prismic/helpers';
import { querySharedServices } from '@/src/domains/shared/services';
import {
  queryAllCustomerEventPages,
  queryCustomerEventPage,
} from '@/src/views/SharedEvents/CustomerEvents/services';

export { CustomerEventPage as default } from '@/src/views/SharedEvents/CustomerEvents';

export async function getStaticProps({ params, previewData, locale }) {
  const { uid } = params;
  const data = await queryCustomerEventPage({ uid, previewData, locale });
  const sharedServices = await querySharedServices({ previewData, locale });
  if (!data) {
    return { notFound: true };
  }

  const body = await getSlicesContext(data.body, {
    webinar_hero_with_form: async ({ slice }) => {
      const { primary } = transformProperties(slice);
      const { hubspotFormId } = primary;
      const { data: hubspotFormDefinition } = await getForm(hubspotFormId);
      return {
        hubspotFormDefinition,
      };
    },
  });

  return {
    props: {
      ...data,
      sharedServices,
      body,
    },
  };
}

export async function getStaticPaths() {
  const customerEventPagesList = await queryAllCustomerEventPages();

  return {
    paths:
      customerEventPagesList?.map((document) => {
        const { uid, lang } = getDocumentMeta(document);
        return {
          params: { uid },
          locale: lang,
        };
      }) || [],
    fallback: false,
  };
}
